import { makeObservable, observable, action, runInAction, toJS } from "mobx";
import moment from "moment";
import { webAPI } from "../api/Api";
import Constants from "../constants/Common";
import reportsAPI from "../api/Reports";
import {
  ExpandableKeys,
  Filter,
  PerPageSettings,
  Sorter,
  WithBooleanFlag,
} from "./core";
import { SearchRequest } from "../api/Types";
import { SortingDirection } from "../constants/Enums";

class SitPanelDailyViolationsReportsStore {
  reports: Array<any> = [];

  isLoading = new WithBooleanFlag();
  paginator = new PerPageSettings();
  sorter = new Sorter();
  filter = new Filter();
  reportParamsRowKeys = new ExpandableKeys();

  reportStatus = "";

  constructor() {
    makeObservable(
      this,
      {
        reports: observable,
        getReports: action,
      },
      {
        deep: true,
      },
    );
    this.filter.setFilterItems({ reportsType: 3 });
    this.sorter.setSortData("created", SortingDirection.Desc);
  }

  getReports = async () => {
    this.isLoading.setTrue();
    try {
      const request = {
        page: this.paginator.page,
        count: this.paginator.perPage,
        sortItems: this.sorter.sortData,
        filterItems: this.filter.filterItems,
      };

      const res = await reportsAPI.getReports(request);
      runInAction(() => {
        this.reports = res.data.items;
        this.paginator.updateMeta(res.data);
      });
    } catch (e) {
      console.log(e);
    } finally {
      this.isLoading.setFalse();
    }
    return toJS(this.reports);
  };
}

const sitPanelDailyViolationsReports =
  new SitPanelDailyViolationsReportsStore();
export default sitPanelDailyViolationsReports;
